module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1531-f344c72cdbe83b6d87c74de1904acc64.png";